export enum SurveyStatus {
  DRAFT = "draft",
  ACTIVE = "active",
  FINISHED = "finished",
}
